<template>
    <div>
        <h3>Top Downloads</h3>
        <h2>{{ month }}</h2>
        <ul>
            <li v-for="map in maps" :key='map._id'>
                <router-link :to="`/review/${map._id}`">
                    <img v-if="map.screenshot" :src="`${siteUrl}/screens/${map.screenshot}`" />
                    <no-image v-else />
                </router-link>
                <div class="map-info">
                    <router-link :to="`/review/${map._id}`">
                        <div class="title"> {{ map.name }}</div>
                    </router-link>
                    <div class="author">by {{ map.author }}</div>
                    <div class="num-downloads">Downloaded {{ map.count }} times</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { api } from '../framework/api';
import { settings } from '../framework/settings';
import NoImage from './primitives/NoImage'
export default {
    components: { NoImage },
    data() {
        return {
            siteUrl: settings.siteUrl,
            month: moment().format('MMMM YYYY'),
            maps: []
        }
    },
    async created() {
        let results = await api.get('downloads');
        this.maps = results.data;
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/TopDownloads.vue